<template>
  <div class="download-page">
    <div class="header">
      <button @click="goBack" class="back-button">
        <!-- 使用简单的左箭头作为返回图标，您可以替换为SVG或图片 -->
        &#x2190; <!-- HTML entity for left arrow -->
      </button>
      <h1>{{ $t('download.title') }}</h1>
    </div>

    <div class="content-card">
      <div class="app-info">
        <!-- 应用Logo已移除 -->
        <h2 class="app-name">{{ $t('download.appName') }}</h2>
        <p class="app-version">{{ $t('download.versionLabel', { version: appVersion }) }}</p>
        <!-- 参考PC版调整描述 -->
        <p class="app-description">{{ $t('download.appDesc') }}</p>
      </div>

      <div class="download-links">
        <h3>{{ $t('download.downloadButtonsTitle') }}</h3>
        <button class="download-button ios" @click="downloadIOS">
          <!-- iOS图标已移除 -->
          {{ $t('download.iosBtn') }}
        </button>
        <button class="download-button android" @click="downloadAndroid">
          <!-- Android图标已移除 -->
          {{ $t('download.androidBtn') }}
        </button>
      </div>

      <div class="features-section">
        <h3>{{ $t('download.featuresTitle') }}</h3>
        <ul class="features-list">
          <li>
            <!-- 图标容器已移除 -->
            <h4>{{ $t('download.feature1Name') }}</h4>
            <p>{{ $t('download.feature1Desc') }}</p>
          </li>
          <li>
            <!-- 图标容器已移除 -->
            <h4>{{ $t('download.feature2Name') }}</h4>
            <p>{{ $t('download.feature2Desc') }}</p>
          </li>
          <li>
            <!-- 图标容器已移除 -->
            <h4>{{ $t('download.feature3Name') }}</h4>
            <p>{{ $t('download.feature3Desc') }}</p>
          </li>
          <li>
            <!-- 图标容器已移除 -->
            <h4>{{ $t('download.feature4Name') }}</h4>
            <p>{{ $t('download.feature4Desc') }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { configList } from '@/api/user.js'; // 引入API

export default {
  name: 'AppDownloadPage',
  data() {
    return {
      // appName 和 appDescription 将通过 i18n 提供
      appVersion: '3.0.0', // 默认版本号，可由API更新
      androidDownloadUrl: '',
      iosDownloadUrl: '',
    };
  },
  mounted() {
    this.loadConfig(); // 页面加载时获取配置
  },
  methods: {
    goBack() {
      this.$router.go(-1); // 或者 this.$router.back();
    },
    loadConfig() {
      configList().then(res => {
        if (res && res.android_download && res.android_download.Value) {
          this.androidDownloadUrl = res.android_download.Value;
        }
        if (res && res.ios_download && res.ios_download.Value) {
          this.iosDownloadUrl = res.ios_download.Value;
        }
        // 如果API返回版本号，可以在此更新 this.appVersion
        // if (res && res.app_version && res.app_version.Value) {
        //   this.appVersion = res.app_version.Value;
        // }
      }).catch(err => {
        console.error('Failed to load download config:', err);
        // 此处可以考虑用户友好的错误提示，例如使用 $t 进行i18n
      });
    },
    downloadIOS() {
      if (this.iosDownloadUrl) {
        this.downloadWithATag(this.iosDownloadUrl);
      } else {
        console.warn('iOS download URL not configured.');
        // 可以在此添加用户提示，例如: alert(this.$t('download.iosLinkNotConfigured'));
      }
    },
    downloadAndroid() {
      if (this.androidDownloadUrl) {
        this.downloadWithATag(this.androidDownloadUrl);
      } else {
        console.warn('Android download URL not configured.');
        // 可以在此添加用户提示，例如: alert(this.$t('download.androidLinkNotConfigured'));
      }
    },
    downloadWithATag(url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
</script>

<style scoped>
.download-page {
  background-color: #121212; /* 更接近截图的深色背景 */
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #333; /* 默认文字颜色，用于卡片内 */
}

.header {
  position: relative; /* 为了back-button的绝对定位或flex对齐 */
  width: 100%; /* 让header占据全部宽度以便内容居中 */
  display: flex; /* 使用flex布局来对齐返回按钮和标题 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 标题居中 */
  margin-bottom: 25px;
}

.back-button {
  position: absolute; /* 相对于.header定位 */
  left: 0; /* 定位到左边 */
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #e0e0e0; /* 与标题颜色一致 */
  font-size: 24px; /* 调整图标大小 */
  padding: 5px 10px; /* 增加点击区域 */
  cursor: pointer;
}

.header h1 {
  color: #e0e0e0;
  /* text-align: center; display:flex 和 justify-content:center 会使其居中 */
  /* margin-bottom: 25px; 移到.header上 */
  font-size: 20px; /* 调整标题大小以适应返回按钮 */
  font-weight: 600;
  margin-left: auto; /* 配合flex布局，确保标题在返回按钮存在时也能居中 */
  margin-right: auto; /* 配合flex布局 */
}

.content-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 25px 30px 25px; /* 增加底部padding */
  width: 100%;
  max-width: 480px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08); /* 柔和阴影 */
}

.app-info {
  text-align: center;
  margin-bottom: 25px;
}

/* .app-logo 样式不再需要，已移除 */

.app-name {
  font-size: 22px; /* 略微调大 */
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
}

.app-version {
  font-size: 13px;
  color: #7f8c8d;
  margin-bottom: 10px;
}

.app-description {
  font-size: 15px;
  color: #555;
  line-height: 1.65;
  margin-top: 8px; /* 与版本号间距 */
}

.download-links h3 {
  font-size: 17px; /* 调整标题大小 */
  font-weight: 600; /* 模仿截图区域标题的粗细 */
  color: #333;
  margin-bottom: 18px;
  text-align: center;
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 15px; /* 调整按钮padding */
  margin-bottom: 12px;
  border-radius: 8px;
  font-size: 16px; /* 略微调大 */
  font-weight: 500;
  cursor: pointer;
  border: none; /* 移除默认边框 */
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.download-button:active {
    transform: scale(0.98); /* 点击反馈 */
}

/* .button-icon 样式不再需要，已移除 */

.download-button.ios {
  background-color: #007aff;
  color: white;
}
.download-button.ios:hover {
  background-color: #005ecb;
}

.download-button.android {
  background-color: #2ecc71;
  color: white;
}
.download-button.android:hover {
  background-color: #25a25a;
}

/* QR Code related styles (qr-code-section, qr-code) were here and are removed as the section is gone */

.features-section {
  margin-top: 30px;
  padding-top: 25px;
  border-top: 1px solid #f0f0f0; /* 分隔线 */
}

.features-section h3 {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px; /* 调整间距 */
  text-align: left;
}

.features-list {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr; /* 改为单列，每个特色占一行 */
  gap: 20px; /* 特色之间的间距 */
}

.features-list li {
  /* display: flex; 已不需要，内部元素默认块级 */
  /* flex-direction: column; */
  /* align-items: center; */
  text-align: left; /* 特色内容左对齐 */
  background-color: #f9f9f9; /* 轻微背景以区分 */
  padding: 15px;
  border-radius: 6px;
}

.features-list li h4 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 6px 0; /* 调整标题边距 */
}

.features-list li p {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  margin: 0;
}

/* .icon-container 及 .feature-icon 样式不再需要，已移除 */

/* .features-list li span:last-child 样式不再需要，已改为 h4 和 p */

/* 响应式调整 */
@media (max-width: 400px) {
  .content-card {
    padding: 15px 20px 25px 20px;
  }
  /* .app-logo 样式不再需要 */
  .app-name {
    font-size: 20px; /* 响应式调整 */
  }
  .features-list {
    gap: 15px; /* 响应式调整间距 */
  }
   .features-list li {
    padding: 12px;
  }
  .features-list li h4 {
    font-size: 15px;
  }
  .features-list li p {
    font-size: 13px;
  }
  /* .icon-container, .feature-icon, .features-list li span:last-child 响应式样式不再需要 */
}
</style>
